"use strict";
/*
 * Profile page dropdown
 */

if (document.querySelector(".profiles-list")) {
  document.addEventListener("DOMContentLoaded", function () {
    // listen for clicks on all revealing blocks
    let profiles = document.querySelectorAll(".profile-item");
    let numProfiles = profiles.length;

    // convert to array so can filter to find clicked profile
    let profilesArray = [].slice.call(profiles);
    console.log("profilesArray", profilesArray);

    // define offset based on screen size
    let profileColumns;
    console.log('site.isMobile', site.isMobile);
    if (site.isMobile) {
      profileColumns = 2;
    } else {
      profileColumns = 4;
    }

    profiles.forEach(function (elem) {
      elem.addEventListener("click", function () {
        // convert json string to js object for ease of use
        let profileDetails = JSON.parse(elem.dataset.details);

        // skip all if no email or bio to show
        // console.log('profileDetails.allowClick', profileDetails.allowClick);

        if (profileDetails.allowClick) {
          // get relative popdown box
          let thisGroup = elem.closest(".profiles-list");
          let theseprofiles = thisGroup.querySelectorAll(".profile-item");
          // convert to array so can filter to find clicked profile
          let theseprofilesArray = [].slice.call(theseprofiles);

          // console.log('theseprofiles', theseprofiles);
          let profilePopdownBox = thisGroup.querySelector(".profile-popdown-box");
          let profilePopdownPicture = profilePopdownBox.querySelector(
            ".profile-popdown-picture-wrapper"
          );
          let profilePopdownLeft = profilePopdownBox.querySelector(
            ".profile-popdown-left"
          );
          let profilePopdownRight = profilePopdownBox.querySelector(
            ".profile-popdown-right"
          );

          // get index of current group only
          let thisIndex = theseprofilesArray.indexOf(elem);
          let nonZeroIndex = thisIndex + 1;
          // console.log('thisIndex', thisIndex);
          // console.log('nonZeroIndex', nonZeroIndex);

          // check if already in last block in row (remainder will be 0)
          if (nonZeroIndex % profileColumns == 0) {
            // console.log('last element in row');
            // set this index
            profilePopdownBox.style.order = nonZeroIndex;
          } else {
            // get index of last item in the row by taking 6 inverse of modulo
            let distanceToLastItemInRow =
              profileColumns - (nonZeroIndex % profileColumns);
            // get last element in row
            let lastElementInRow =
              profilesArray[thisIndex + distanceToLastItemInRow];

            // last row element exists, but dont need undefined b/c know it exists from https://stackoverflow.com/a/5515349/4504073
            if (lastElementInRow) {
              // get index of last element in the row and set it
              profilePopdownBox.style.order =
                [].indexOf.call(profilesArray, lastElementInRow) + 1;

              // if no last element b/c incomplete last row, put at end
            } else {
              profilePopdownBox.style.order = 520; // more than ever before
            }
          }

          // document.getElementsByTagName('body')[0].classList.remove('open-nav');
          // alert('show profile box');
          // thisGroup.classList.toggle("show-profile");

          // turn off if same as already open
          // console.log('elem', elem);
          let isCurrentProfile = elem.classList.contains('show-me');
          console.log('isCurrentProfile', isCurrentProfile);
          if(isCurrentProfile) {
            thisGroup.classList.remove("show-profile");
            elem.classList.remove('show-me');
          } else {
            thisGroup.classList.add("show-profile");
            // remove .show-me from all profiles
            profiles.forEach(function (profileElem) {
              profileElem.classList.remove('show-me');
            });
            // add it to this one
            elem.classList.add('show-me');
          }

          // loop through left side
          profilePopdownLeft.childNodes.forEach(function (elem) {
            console.log(elem);
            let elemID = elem.id;
            // if have any new data, set it
            if (profileDetails.hasOwnProperty(elemID)) {
              elem.innerHTML = profileDetails[elemID];
            }
          });

          // loop through right side
          profilePopdownRight.childNodes.forEach(function (elem) {
            // console.log(elem);
            let elemID = elem.id;
            // if have any new data, set it
            if (profileDetails.hasOwnProperty(elemID)) {
              elem.innerHTML = profileDetails[elemID];
            }
          });

          // // scroll there
          // let anchor = elem.querySelector("#" + elem.dataset.anchor);
          // anchor.scrollIntoView({behavior: "instant"});
        }
      });
    });

    // close button
    let profileCloseButton = document.querySelectorAll(
      ".profile-popdown-close-wrapper"
    );

    profileCloseButton.forEach(function (button) {
      button.addEventListener("click", function () {
        button.closest(".profiles-list").classList.remove("show-profile");
      });
    });
  })
}
